import React from 'react';
import classnames from 'classnames';

import { colors } from 'components/styles/variables';

export interface ReviewTitleContentProps {
  children: string;
  className?: string;
}

export function ReviewTitleContent(props: ReviewTitleContentProps): JSX.Element {
  return (
    <>
      <div className={classnames('review-title-content', props.className)}>{props.children}</div>
      <style jsx>{`
        .review-title-content {
          font-weight: 700;
          font-size: 20px;
          line-height: 28px;
          letter-spacing: 0.2px;
          color: ${colors.BLACK};
          padding-bottom: 4px;
        }
      `}</style>
    </>
  );
}

export interface ReviewBodyContentProps {
  children: string;
}

export function ReviewBodyContent(props: ReviewBodyContentProps): JSX.Element {
  return (
    <>
      <div className="review-body-content">{props.children}</div>
      <style jsx>{`
        .review-body-content {
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          letter-spacing: 0.2px;
          color: ${colors.BLACK};
          margin-bottom: 16px;
          // allows ellipsis overflow on second line. see: https://stackoverflow.com/questions/5269713/css-ellipsis-on-second-line
          display: -webkit-box;
          -webkit-line-clamp: 6;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      `}</style>
    </>
  );
}
